import './upload.component.scss';
import Button from 'react-bootstrap/Button';
import Uppy from '@uppy/core';
import { useNavigate } from 'react-router-dom';
import { DragDrop } from '@uppy/react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';
import './upload.component.scss';
import { useMutation } from '@apollo/client';
import { CreateEnterpriseEmployeeFile } from '../../../../Mutations/MutationsUpdated';
import { useSelector } from 'react-redux';
import XHRUpload from '@uppy/xhr-upload';
// import isEqual from 'lodash/isEqual';
// import _ from 'lodash';

const initializeUppy = () => {
  return new Uppy({
    id: 'health_analysis_consumer_data',
    restrictions: {
      maxNumberOfFiles: 1,
      maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE,
      allowedFileTypes: ['.csv'],
      fileManagerSelectionType: 'folder',
    },
    // bundle: true,
    autoProceed: false,
    onBeforeFileAdded: (currentFile, files) => {
      let empFilesArr = Object.values(files);
      if (empFilesArr.length > 0) {
        if (empFilesArr.find((x) => x.name === currentFile.meta.name)) {
          empFilesUppy.removeFile(currentFile.id);
          toast.error(
            toastResponse(
              'error',
              `Cannot add the duplicate file ${currentFile.meta.name}, it already exists`,
            ),
          );
        } else {
          empFilesUppy.removeFile(currentFile.id);
          toast.error(
            toastResponse('error', 'You can not upload more than 1 file....'),
          );
        }
      } else if (currentFile.extension !== 'csv') {
        empFilesUppy.removeFile(currentFile.id);
        toast.error(toastResponse('error', 'You can upload only csv file....'));
      }
    },
    logger: {
      debug: (e) => {},
      warn: (e) => {},
      error: (error, response) => {
        console.log(error);
      },
    },
  });
};

// Initialize Uppy
const empFilesUppy = initializeUppy();

// Handle the window.onpopstate event
window.onpopstate = function (event) {
  // Check if empFilesUppy is initialized before attempting to close it
  if (empFilesUppy) {
    empFilesUppy.close();
  }
};

export const UploadEmployee = () => {
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.authReducer);
  const [selectedEmpFile, setSelectedEmpFile] = useState([]);
  const [basicUploadFileInfo, setBasicUploadFileInfo] = useState({});

  const downloadCSV = () => {
    // let data = "UHJvZHVjdE5hbWUsUHJvZHVjdFR5cGUsQW5udWFsRmVlcyxMb2FuUHJvY2Vzc2luZ0ZlZXMsSW50ZXJlc3RSYXRlLEludGVyY2hhbmdlZmVlCkJhc2ljIEF1dG8gTG9hbixBdXRvIExvYW4sMCwyNTAsMywwClNtYWxsIEJ1c2luZXNzIExvYW4sQnVzaW5lc3MgTG9hbiwwLDgwMCw2LDAKQmFzaWMgQ3JlZGl0IENhcmQsQ3JlZGl0IENhcmQsMTUwLDAsMTIsMC4wMDIKQmFzaWMgU3R1ZGVudCBMb2FuLFN0dWRlbnQgTG9hbiwwLDM1MCw0LDAKU21hbGwgUGVyc29uYWwgTG9hbixQZXJzb25hbCBMb2FuLDAsNDAwLDEwLDAKQmFzaWMgTW9ydGdhZ2UsTW9ydGdhZ2UsMCw0NTAsNiwwCg==";

    var encodedUri =
      'Employee ID,first name,last name,email,phone number,address,ssn\n 1,John,Doe,johndoe@example.com,555-123-4567,123 Main St,123-45-6789\n 2,Alice,Smith,alicesmith@example.com,555-987-6543,456 Elm St,123-45-6789\n 3,Michael,Johnson,michael@example.com,555-789-1234,789 Oak St,123-45-6789\n 4,Emma,Williams,emma@example.com,555-321-7890,321 Pine St,123-45-6789\n 5,William,Brown,william@example.com,555-555-5555,567 Maple St,123-45-6789';
    // let binaryData = window.atob(data);
    // var csvContent = binaryData;
    // var encodedUri = encodeURI(csvContent);
    var link = document.createElement('a');
    link.setAttribute(
      'href',
      'data:text/csv;charset=utf-8,\uFEFF' + encodedUri,
    );
    link.setAttribute('download', 'Sample template.csv');
    link.click();
  };

  //Assign mutaions to variable
  const [UploadEnterpriseEmployeeFile] = useMutation(
    CreateEnterpriseEmployeeFile,
    {
      onCompleted: (data) => {
        setBasicUploadFileInfo(data.createEmployeeCSV);
        toast.success(toastResponse('success', 'File uploaded successfully..'));
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    },
  );

  // useEffect(() => {
  //     empFilesUppy.on('file-added', (file) => {
  //         setSelectedEmpFile(selectedEmpFile => ([...selectedEmpFile, { ...file }]));

  //         if (selectedEmpFile) {
  //             debugger
  //             UploadEnterpriseEmployeeFile({ variables: { enterpriseId: authReducer.enterpriseID } });
  //         }
  //     });
  // }, [])

  useEffect(() => {
    const fileAddedHandler = (file) => {
      setSelectedEmpFile((prevFiles) => [...prevFiles, { ...file }]);
    };

    // Add the file-added event listener
    empFilesUppy.on('file-added', fileAddedHandler);

    // Clean up the event listener when the component is unmounted
    return () => {
      empFilesUppy.off('file-added', fileAddedHandler);
    };
  }, []); // Dependency array to ensure the effect runs when empFilesUppy changes

  useEffect(() => {
    // Check if there are selectedEmpFile and it's not an empty array
    if (selectedEmpFile.length > 0) {
      UploadEnterpriseEmployeeFile({
        variables: { enterpriseId: authReducer.enterpriseID },
      });
    }
  }, [selectedEmpFile, UploadEnterpriseEmployeeFile, authReducer.enterpriseID]);

  const fnSubmitEmployeeFile = () => {
    if (selectedEmpFile) {
      const presignedURL = basicUploadFileInfo?.presignedURL;
      sessionStorage.setItem('file id', basicUploadFileInfo?.id);

      try {
        // Use the fetch API to upload the image to the pre-signed URL
        if (presignedURL) {
          selectedEmpFile.forEach((item) => {
            empFilesUppy.setFileState(item.id, {
              xhrUpload: {
                id: item.id,
                endpoint: presignedURL,
              },
            });
          });
          empFilesUppy.use(XHRUpload, {
            method: 'put',
            formData: false,
          });

          empFilesUppy.upload();
          navigate('/enterprise/enterprise-admin/data-mapping');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };

  return (
    <>
      <div className="h-xxl-100 upload_data_bg_img">
        <div className="row pb-5">
          <div className="col-md-12">
            <h5 className="fw-bolder fs-4 text-dark pt-4 pb-0 shrinkTitle">
              Upload{' '}
            </h5>
            <div className="breadcrumbs">
              <button
                type="button"
                className="theme breadcrumbs-links btn btn-link p-0"
                onClick={() =>
                  navigate('/enterprise/enterprise-admin/dashboard')
                }
              >
                Dashboard{' '}
              </button>
              <button
                type="button"
                className="theme breadcrumbs-links btn btn-link p-0"
              >
                {' '}
                Upload
              </button>
            </div>
          </div>
        </div>

        <div className="row px-10 center_align_block">
          <div className="row justify-content-between">
            <div className="col-md-12 text-center">
              <h3 className="fs-4 fw-bolder">Upload Data</h3>
              <p
                className="wizardPageSubTitle fw-normal fs-7 mb-0"
                style={{ width: '40%', margin: '0 auto' }}
              >
                Providing employee data helps us create more impactful insights.
                Download the template, fill it in and upload the file according
                to its size.
              </p>
            </div>
            <div className="col-xl-12 mb-2">
              <div className="row d-flex justify-content-center">
                <div className="col-md-4">
                  <div className="position-relative">
                    <section
                      id="employeeData"
                      className="employeeData pt-8 pt-xxl-0"
                      style={{ zIndex: '0' }}
                    >
                      {empFilesUppy && (
                        <DragDrop
                          uppy={empFilesUppy}
                          id="dragdrop_empFileuppy"
                          locale={{
                            strings: {
                              dropHereOr:
                                'To upload, drag and drop the Employee File or %{browse}',
                              browse: 'browse',
                            },
                          }}
                        />
                      )}
                    </section>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-md-4 text-center"
              style={{ zIndex: '1', margin: '0 auto' }}
            >
              <Button
                className="customTable action-btn btn btn-primary btn-hover-color"
                onClick={downloadCSV}
              >
                Download templates
              </Button>
            </div>

            <div
              className="col-xs-12 col-md-12 col-xl-12 text-center"
              style={{ marginTop: '8rem', zIndex: '1', marginBottom: '1rem' }}
            >
              <Button
                className="btn btn-secondary px-12  me-2"
                onClick={() => {
                  navigate('/enterprise/enterprise-admin/dashboard');
                  empFilesUppy.close();
                }}
              >
                Back
              </Button>
              <Button
                className="customTable action-btn btn btn-primary px-12 btn-hover-color"
                disabled={Object.keys(basicUploadFileInfo).length === 0}
                onClick={() => {
                  fnSubmitEmployeeFile();
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
